import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { Home } from './pages/Home';
import { Entities } from './pages/Entities';
import { ReviewLogs } from './pages/ReviewLogs';

function PrivateRoute({ children }: { children: React.ReactNode }) {
    const token = localStorage.getItem('token');
    return token ? <>{children}</> : <Navigate to="/login" />;
}

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={
                    <PrivateRoute>
                        <Layout />
                    </PrivateRoute>
                }>
                    <Route index element={<Home />} />
                    <Route path="entities" element={<Entities />} />
                    <Route path="review_log" element={<ReviewLogs />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
